(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-footer"] && !Shopify.designMode) return;
  try {
    
  /* Opens/closes the menu dropdowns on mobile (on desktop they are always open) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.sf__toggle');
    if (!btn) return;
    if (window.matchMedia('(min-width: 750px)').matches) return;
    var open = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', open ? 'false' : 'true');
    btn.parentElement.classList.toggle('is-open', !open);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-category"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(scroller) {
      if (scroller.dataset.sbcReady) return;
      scroller.dataset.sbcReady = '1';

      var down = false, moved = false, startX = 0, startLeft = 0;

      scroller.addEventListener('mousedown', function (e) {
        down = true;
        moved = false;
        startX = e.pageX;
        startLeft = scroller.scrollLeft;
      });
      window.addEventListener('mousemove', function (e) {
        if (!down) return;
        var dx = e.pageX - startX;
        if (Math.abs(dx) > 5) {
          moved = true;
          scroller.classList.add('is-dragging');
        }
        if (moved) scroller.scrollLeft = startLeft - dx;
      });
      window.addEventListener('mouseup', function () {
        if (!down) return;
        down = false;
        scroller.classList.remove('is-dragging');
      });
      /* Don't open a collection if the user was just dragging */
      scroller.addEventListener('click', function (e) {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
          moved = false;
        }
      }, true);
    }

    function initAll() {
      document.querySelectorAll('.sbc__scroller').forEach(init);
    }

    initAll();
    document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
